import { footerGroups, footerTags } from "@/mocks/cgua";

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50/85">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2">
            <a href="#top" className="flex items-center gap-2 cursor-pointer">
              <span className="flex items-center justify-center w-8 h-8 rounded-full bg-accent-500 text-primary-950">
                <i className="ri-flashlight-fill text-base" />
              </span>
              <span className="font-heading text-2xl font-extrabold text-background-50">17吃瓜</span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-background-50/75 max-w-xs">
              把散落的热搜、八卦与时事按合集、汇总、盘点与精选收好，让你每次打开都能一口气补上吃瓜进度。
            </p>
            <div className="mt-5 flex gap-2">
              <a href="#" aria-label="微博" className="flex items-center justify-center w-9 h-9 rounded-full bg-background-50/10 hover:bg-background-50/20 text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-base" />
              </a>
              <a href="#" aria-label="抖音" className="flex items-center justify-center w-9 h-9 rounded-full bg-background-50/10 hover:bg-background-50/20 text-background-50 transition-colors cursor-pointer">
                <i className="ri-music-2-line text-base" />
              </a>
              <a href="#" aria-label="小红书" className="flex items-center justify-center w-9 h-9 rounded-full bg-background-50/10 hover:bg-background-50/20 text-background-50 transition-colors cursor-pointer">
                <i className="ri-article-line text-base" />
              </a>
              <a href="#" aria-label="公众号" className="flex items-center justify-center w-9 h-9 rounded-full bg-background-50/10 hover:bg-background-50/20 text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-base" />
              </a>
            </div>
          </div>

          {footerGroups.map((g) => (
            <div key={g.title}>
              <h3 className="text-sm font-bold text-background-50 mb-3.5">{g.title}</h3>
              <ul className="space-y-2.5">
                {g.items.map((it) => (
                  <li key={it}>
                    <a
                      href="#"
                      className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {it}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 border-t border-background-50/10 pt-6">
          <h3 className="sr-only">热点标签</h3>
          <div className="flex flex-wrap gap-2">
            {footerTags.map((t) => (
              <a
                key={t}
                href="#"
                className="rounded-full bg-background-50/10 text-background-50/80 text-xs px-3 py-1.5 hover:bg-background-50/20 transition-colors cursor-pointer"
              >
                #{t}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-background-50/10 pt-5 text-xs text-background-50/60">
          <p>© 2026 17吃瓜 · 让每一次打开都物超所值</p>
          <div className="flex items-center gap-4">
            <a href="#" className="hover:text-background-50 cursor-pointer">关于我们</a>
            <a href="#" className="hover:text-background-50 cursor-pointer">内容规范</a>
            <a href="#" className="hover:text-background-50 cursor-pointer">联系方式</a>
          </div>
        </div>
      </div>
    </footer>
  );
}